import React from "react";
import { SCREEN_TOTAL } from "../componets/commonUtils";

export function CvContainer() {
  const mapAllScreens = () => {
    return SCREEN_TOTAL.map((screen) =>
      screen.component ? (
        <screen.component
          screenName={screen.screen_name}
          key={screen.screen_name}
          id={screen.screen_name}
        />
      ) : (
        <div key={screen.screen_name} />
      )
    );
  };
  return <div className={"cv-container"}>{mapAllScreens()}</div>;
}
